import {
  GET_AGENT_INFO_BY_CODE,
  SET_AGENT_INFO_BY_CODE,
  GET_OPM_ASSIGNMENT_LIST,
  SET_OPM_ASSIGNMENT_LIST,
  GET_AGENTS_UNDER_AD,
  SET_AGENTS_UNDER_AD,
  GET_ELIGIBLE_POLICIES,
  SET_ELIGIBLE_POLICIES,
  GET_SUITABLE_AGENTS,
  SET_SUITABLE_AGENTS,
  APPROVE_OPM_ASSIGNMENT,
  REJECT_OPM_ASSIGNMENT,
} from './constants';

export const getAgentInfoByCodeAction = (payload) => ({
  type: GET_AGENT_INFO_BY_CODE,
  payload,
});

export const setAgentInfoByCodeAction = (payload) => ({
  type: SET_AGENT_INFO_BY_CODE,
  payload,
});

export const getOpmAssignmentListAction = (payload) => ({
  type: GET_OPM_ASSIGNMENT_LIST,
  payload,
});

export const setOpmAssignmentListAction = (payload) => ({
  type: SET_OPM_ASSIGNMENT_LIST,
  payload,
});

export const getAgentsUnderAdAction = (payload) => ({
  type: GET_AGENTS_UNDER_AD,
  payload,
});

export const setAgentsUnderAdAction = (payload) => ({
  type: SET_AGENTS_UNDER_AD,
  payload,
});

export const getEligiblePoliciesAction = (payload) => ({
  type: GET_ELIGIBLE_POLICIES,
  payload,
});

export const setEligiblePoliciesAction = (payload) => ({
  type: SET_ELIGIBLE_POLICIES,
  payload,
});

export const getSuitableAgentsAction = (payload) => ({
  type: GET_SUITABLE_AGENTS,
  payload,
});

export const setSuitableAgentsAction = (payload) => ({
  type: SET_SUITABLE_AGENTS,
  payload,
});

export const approveOpmAssignmentAction = (payload) => ({
  type: APPROVE_OPM_ASSIGNMENT,
  payload,
});

export const rejectOpmAssignmentAction = (payload) => ({
  type: REJECT_OPM_ASSIGNMENT,
  payload,
});
